import React from "react";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import {
  CardContent,
  Grid,
  Card as MuiCard,
  LinearProgress,
} from "@mui/material";

import * as Enums from "src/utils/enums";
import useForm from "src/hooks/useForm";

import { getNextCode } from "src/services/generalService";
import { DefaultService } from "src/services/defaultService";

import AMIndexList from "src/pages/components/AMIndexList";
import TestFooter from "./TestFooter";

const Card = styled(MuiCard)(spacing);

function TestPage({ menuItemCode }) {
  const defaultService = new DefaultService("SampleTable");

  //#region Api Calls
  const getNextCodeFunc = async () => {
    const { data } = await getNextCode(menuItemCode, "code", "");
    return data || "";
  };

  const getByIdFunc = async (id) => {
    const { data } = await defaultService.get(menuItemCode, id);
    //Remove id if rendered from server to keep id as it comes from url and not enter in infinite loop
    if (data) delete data.id;
    return data;
  };

  const saveFormFunction = async (menuItemCode, formData) => {
    const { data } = await defaultService.save(menuItemCode, formData);
    return data;
  };

  const deleteFunction = async (menuItemCode, formData) => {
    const { data } = await defaultService.delete(menuItemCode, formData);
    return data;
  };
  //#endRegion

  const {
    state: values,
    handleSetState,
    indexColumns,
    renderFormHeader,
    renderFormInput,
    preLoaded,
    formControls,
  } = useForm({
    menuItemCode: menuItemCode,
    nextCodeField: "code",
    getNextCodeFunc: getNextCodeFunc,
    getByIdFunc: getByIdFunc,
    saveFunction: saveFormFunction,
    deleteFunction: deleteFunction,
  });

  //#region Save Details
  const handleSetSampleTableFooter = (newSampleTableFooter) => {
    const newState = { ...values };
    newState.sampleTableFooter = [...newSampleTableFooter];
    handleSetState(newState);
  };
  //#endregion

  if (!preLoaded) return <LinearProgress my={2} />;

  const mainData = (
    <Card mb={6}>
      <CardContent>
        <Grid container spacing={4}>
          {renderFormInput("code", Enums.ControlType.TextField, {
            disabled: true,
            style: { maxWidth: 100 },
          })}
          {renderFormInput("name_Ar")}
          {renderFormInput("name_En")}
          {renderFormInput("notActive", Enums.ControlType.CheckBox)}
          {renderFormInput("transDate", Enums.ControlType.DatePicker)}
          {renderFormInput("countryId", Enums.ControlType.AutoSearch)}
        </Grid>
      </CardContent>
    </Card>
  );

  return (
    <React.Fragment>
      {renderFormHeader()}
      {!values.id && indexColumns && !!indexColumns.length && (
        <AMIndexList
          key={indexColumns.length}
          columns={indexColumns}
          // title={title}
          // filterControls={filterControls}
          // criteria={criteria}
          // onApplyFilter={onApplyFilter}
          getAll={defaultService.getAll}
        />
      )}
      {!!values.id && (
        <Grid container spacing={4}>
          <Grid item xs={12}>
            {mainData}
          </Grid>
          <Grid item xs={12}>
            <TestFooter
              formControls={formControls}
              title="Test Footer"
              // saveRow={handleSaveRow}    I've moved this functions to the chiled component
              // deleteRow={handleDeleteRow}
              tableData={values.sampleTableFooter || []}
              setTableData={handleSetSampleTableFooter}
            />
          </Grid>
        </Grid>
      )}
    </React.Fragment>
  );
}

export default TestPage;
